export const data = [
  {
    question: "What does the acronym 'ETF' stand for?",
    option1: "Equity Trading Fund",
    option2: "Exchange Traded Fund",
    option3: "Electronic Transfer Fund",
    option4: "Equity Transfer Fund",
    ans: 2,
  },
  {
    question: "Which of the following is a primary market activity?",
    option1: "Buying shares on the stock exchange",
    option2: "Issuing new shares to the public ",
    option3: "Trading in mutual funds",
    option4: "Purchasing bonds from other investors",
    ans: 2,
  },
  {
    question: "What is a 'bull market'?",
    option1: " market where prices are falling",
    option2: " A market with high trading volumes",
    option3: "A market where prices are rising ",
    option4: "A market with low trading volumes",
    ans: 3,
  },
  {
    question:
      "Which financial ratio measures a company's profitability relative to its total assets?",
    option1: "Price-to-Earnings Ratio (P/E)",
    option2: "Debt-to-Equity Ratio (D/E)",
    option3: "Return on Assets (ROA",
    option4: "Current Ratio",
    ans: 3,
  },
  {
    question: "What does 'diversification' in investing aim to do?",
    option1: "Increase the potential returns",
    option2: "Decrease the overall risk",
    option3: "Concentrate investments in one sector",
    option4: "Focus on short-term gains",
    ans: 2,
  },
  {
    question: "What is a 'blue-chip' stock?",
    option1: "A stock of a well-established and financially sound company ",
    option2: "A stock with high volatility",
    option3: "A stock in the technology sector",
    option4: "A newly issued stock",
    ans: 3,
  },
  {
    question: "Which of the following best describes 'market capitalization'?",
    option1: "The total amount of capital raised by a company",
    option2: "The total value of a company's outstanding shares of stock",
    option3: "The maximum price a stock has reached in the past year",
    option4: "The total revenue generated by a company",
    ans: 2,
  },
  {
    question: "What does a 'bear market' indicate?",
    option1: "A market where prices are stable",
    option2: " A market with increasing stock prices",
    option3: "A market with decreasing stock prices",
    option4: "A market with low trading volumes",
    ans: 3,
  },
  {
    question: "What does 'diversification' in investing aim to do?",
    option1: "A market where prices are stable",
    option2: " A market with increasing stock prices",
    option3: " A market with decreasing stock prices",
    option4: "A market with low trading volumes",
    ans: 3,
  },
  {
    question: "What is the main purpose of a stock split?",
    option1: "To decrease the number of shares outstanding",
    option2: "To increase the stock price",
    option3: "To distribute dividends",
    option4: "To make the stock more affordable to small investors",
    ans: 4,
  },
];
